export const DLG_ECM_FAT = 0.38;
export const DLG_ECM_PROTEIN = 0.21;
export const DLG_ECM_OFFSET = 1.05;
export const DLG_ECM_DIVISOR = 3.28;
